import { useCallback, useState } from 'react';
import { UserHttp } from '@/services';

export const useOldView = () => {
  const [loading, setLoading] = useState(false);

  const toOldView = useCallback(() => {
    setLoading(true);
    UserHttp.loginToken().then(response => {
      UserHttp.redirectToOld(response.data?.payload?.loginAsToken);
    }).finally(() => setLoading(false));
  }, []);

  return { loading, toOldView };
};

export default useOldView;
